import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import type { MessageDescriptor } from 'react-intl';

import { IconButton } from 'ui-components/components/button/icon-button';
import { Text, TextType } from 'ui-components/components/text';

import style from 'ui-components/components/drawer/drawer-header.module.less';

type TransferOrderDrawerHeaderProps = {
  title?: string;
  closeButtonAriaLabel: MessageDescriptor;
  onClose: () => void;
};

export const TransferOrderDrawerHeader = ({ title = '', closeButtonAriaLabel, onClose }: TransferOrderDrawerHeaderProps) => {
  return (
    <div className={style['header-wrapper']}>
      <Text className={style.title} textType={TextType.H4} value={title} />
      <div className={style['close-wrapper']}>
        <IconButton ariaLabelMessageDescriptor={closeButtonAriaLabel} icon={faTimes} onClick={onClose} />
      </div>
    </div>
  );
};
